/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignmentPriority } from './AssignmentPriority';
import {
    AssignmentPriorityFromJSON,
    AssignmentPriorityFromJSONTyped,
    AssignmentPriorityToJSON,
    AssignmentPriorityToJSONTyped,
} from './AssignmentPriority';

/**
 * 
 * @export
 * @interface UpdateAssignmentRequest
 */
export interface UpdateAssignmentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAssignmentRequest
     */
    description: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateAssignmentRequest
     */
    dueDate: Date;
    /**
     * 
     * @type {AssignmentPriority}
     * @memberof UpdateAssignmentRequest
     */
    priority: AssignmentPriority;
    /**
     * 
     * @type {string}
     * @memberof UpdateAssignmentRequest
     */
    assignedCounselorId: string;
}



/**
 * Check if a given object implements the UpdateAssignmentRequest interface.
 */
export function instanceOfUpdateAssignmentRequest(value: object): value is UpdateAssignmentRequest {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('assignedCounselorId' in value) || value['assignedCounselorId'] === undefined) return false;
    return true;
}

export function UpdateAssignmentRequestFromJSON(json: any): UpdateAssignmentRequest {
    return UpdateAssignmentRequestFromJSONTyped(json, false);
}

export function UpdateAssignmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAssignmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'dueDate': (new Date(json['dueDate'])),
        'priority': AssignmentPriorityFromJSON(json['priority']),
        'assignedCounselorId': json['assignedCounselorId'],
    };
}

export function UpdateAssignmentRequestToJSON(json: any): UpdateAssignmentRequest {
    return UpdateAssignmentRequestToJSONTyped(json, false);
}

export function UpdateAssignmentRequestToJSONTyped(value?: UpdateAssignmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'dueDate': value['dueDate'].toISOString(),
        'priority': AssignmentPriorityToJSON(value['priority']),
        'assignedCounselorId': value['assignedCounselorId'],
    };
}

